<template>
  <div class="about-diabetes page">
    <div class="about-diabetes__background"></div>
    <img
      width="30"
      src="../assets/img/illustrations/bulp.png"
      class="bulp-illustration"
    />
    <div class="container">
      <SectionHeader
        title="O nadváze a obezitě"
        text="Obezita je chronické onemocnění vyžadující většinou celoživotní léčbu. V současnosti v ČR obezitou trpí pětina dospělé populace a téměř polovina žije s nadváhou. Jde o podceňované závažné metabolické onemocnění, které může vést k rozvoji těžkých komplikací, a dokonce i k předčasnému úmrtí. Obezita je celosvětovou pandemií."
      />

      <SectionPromoMobileApp />

      <section class="primary--text">
        <v-row class="card" align="center" justify="center">
          <v-col md="3" cols="12" class="pa-0 pr-0 pr-md-4">
            <v-img
              max-width="100%"
              src="https://novocare.b-cdn.net/wegovy/obesity-image-min.png"
            ></v-img>
          </v-col>
          <v-col class="mb-12 mb-md-0" md="9" cols="12">
            <h1 class="mb-4">Kdy mluvíme o obezitě?</h1>
            <div>
              Za normální hmotnost je považována hodnota BMI mezi 18,5 a 25.
              Většina populace mívá nadváhu, jejich BMI se pohybuje mezi 25 a
              30. Jako obezita prvního stupně se označuje BMI 30 až 35, obezitu
              druhého stupně pak představuje hodnota 35 až 40. Pokud BMI
              přesáhne 40, jde o obezitu třetího stupně. Orientačním ukazatelem
              nadváhy a nezdravého rozložení tuku v těle je i obvod pasu:
              zpozornět by měli muži při obvodu pasu nad 102 cm a ženy při
              hodnotě nad 88 cm.
            </div>
          </v-col>
        </v-row>
      </section>

      <section class="primary--text">
        <a
          href="https://www.netloustneme.cz/"
          target="_blank"
          class="text-decoration-none"
        >
          <div class="white pa-4">
            <h1>Chcete vědět více o nadváze či obezitě?</h1>
            <div class="mt-4">Přejděte na web Netloustneme.cz.</div>
            <v-img
              max-width="400"
              src="https://novocare.b-cdn.net/wegovy/netlousneme-logo.png"
            ></v-img>
          </div>
        </a>
      </section>
    </div>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader.vue";
import SectionPromoMobileApp from "../components/SectionPromoMobileApp.vue";

export default {
  components: { SectionHeader, SectionPromoMobileApp },
};
</script>

<style lang="scss" scoped>
.about-diabetes {
  background: var(--v-primary-base);
  height: 100%;
  position: relative;
  &__background {
    background: var(--v-bgLight-base);
    height: 80rem;
    width: 100%;
    position: absolute;
    left: 0;
    top: -5rem;
  }

  .bulp-illustration {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    top: -3rem;
  }

  .card-wrapper {
    position: relative;

    .human-illustration {
      position: absolute;
      left: -3rem;
      top: -4rem;
    }
  }

  .card {
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    background: white;

    &-title {
      color: var(--v-primary-base);
    }

    &-text {
      margin: 1rem 0;
      min-height: 9rem;
    }
  }
}
</style>
